
let map;

async function initMap() {
    // The location of Australia
    const position_center = { lat: -25.426405461990637, lng: 133.57156546972354 };

    const { Map } = await google.maps.importLibrary("maps");
    //const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

    // The map, centered at Australia
    map = new Map(document.getElementById("map"), {
        zoom: 5,
        center: position_center,
        mapId: "ef15d24bd28aea8d",
    });

    google.maps.event.addListener(map, 'click', function(){
       if(activeWindow != null) activeWindow.close();
    })

    const iconBase = "https://cdn.shopify.com/s/files/1/0417/9994/2308/files/pin_387fa5ff-512d-45e4-b814-cc6860bc2c45.png?v=1683612126";

    const locations = []
    const mapLocations = document.querySelectorAll('[data-mapLocation]');
    mapLocations.forEach(location => {
       let loc = location.getAttribute('data-mapLocation').split(",")
       let locId = location.getAttribute('data-locationId')
       let locName = location.getAttribute('data-locationName')
       let loclink = location.getAttribute('data-locationLink')
       locations.push({position: new google.maps.LatLng(loc[0], loc[1]), locationId: locId, locationName: locName, locationLink: loclink})
      
    });

    var activeWindow;
    for (let i = 0; i < locations.length; i++) {
        const marker = new google.maps.Marker({
            position: locations[i].position,
            icon: iconBase,
            map: map
        });

        const contentString = '<div class="info-window-custom"><div class="info-window-title">'+locations[i].locationName+'</div><div class="info-window-link"><a href="'+locations[i].locationLink+'" target="_blank">View Map</a></div></div>';
        
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          pixelOffset: 0
        });
      
        marker.addListener("click", () => {
          if(activeWindow != null) activeWindow.close();
          
          infowindow.open({
            anchor: marker,
            map,
          });

          activeWindow = infowindow;
        });

      
        // marker.addListener("mouseover", () => {
        //   infowindow.open({
        //     anchor: marker,
        //     map,
        //   });
        // });
        // marker.addListener("mouseout", () => {
        //   infowindow.close();
        // });
        //marker.addListener('click', markerClickListener(locations[i].locationId));
    }

}

// document.getElementById("map").addListener('click', () => {
//     console.log('sssss');
//    if(activeWindow != null) activeWindow.close();
// });

// function markerClickListener(locationId) {
//   return function() {

//     console.log(locationId)
    
//     const section = document.getElementById(locationId);

//     // remove all active classes
//     const elements = document.querySelectorAll('.active');
//     for (let i = 0; i < elements.length; i++) {
//       elements[i].classList.remove('active');
//     }
    
//     section.classList.add('active')
//     section.scrollIntoView({ behavior: 'smooth' });
//   }
// }